import {
  Typography,
  Grid,
  InputAdornment,
  IconButton,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import DocumentsTable from "./DocumentsTable";

interface IProps {
  search: string;
  handleSearchTyping: (e: any) => void;
  handleFetchStoredDocuments: () => void;
  storedDocuments: any;
  handleRetrainDocuments: (id: string) => void;
  handleDeleteDocument: (id: string) => void;
  setFileUploading: (value: any) => void;
  handleClearSearch: () => void;
  setStoredDocuments: any;
  loading: boolean;
  isChatGPTAPIKeyValid?: boolean;
}

const StoredDocuments = ({
  handleClearSearch,
  handleDeleteDocument,
  handleFetchStoredDocuments,
  handleRetrainDocuments,
  handleSearchTyping,
  search,
  setFileUploading,
  setStoredDocuments,
  storedDocuments,
  loading,
  isChatGPTAPIKeyValid,
}: IProps) => {
  return (
    <Grid container mt="40px">
      <Grid
        container
        item
        xs={12}
        sx={{
          paddingBottom: "10px",
          borderBottom: "1px solid rgba(32, 33, 36, 0.1)",
        }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid
          item
          md={6}
          xs={12}
          className="knowledgebase-header-container left"
        >
          <Typography
            sx={{
              color: "#202124",
              fontSize: "16px",
              fontWeight: 600,
            }}
          >
            Knowledge base List
            <Button
              className="guideTourKBRefreshKnwldge"
              variant="outlined"
              size="small"
              sx={{
                marginLeft: "15px",
                fontSize: "10px!important",
              }}
              onClick={handleFetchStoredDocuments}
            >
              REFRESH KNOWLEDGE BASE
            </Button>
          </Typography>
        </Grid>

        <Grid
          item
          md={6}
          xs={12}
          textAlign="right"
          className="knowledgebase-header-container right"
        >
          <TextField
            value={search}
            onChange={handleSearchTyping}
            sx={{
              border: "0!important",
              "& .MuiInputBase-root": {
                height: "34px",
                borderRadius: "8px",
                background: "rgba(32, 33, 36, 0.03)",
                color: "rgba(32, 33, 36, 0.7)",
                fontSize: "12px",
              },
            }}
            variant="outlined"
            placeholder="search"
            InputProps={{
              endAdornment: (
                <>
                  {search && (
                    <InputAdornment position="end" onClick={handleClearSearch}>
                      <IconButton
                        aria-label="search icon"
                        edge="end"
                        className="search-fb-icon"
                      >
                        <CloseIcon className="cursor-pointer" />
                      </IconButton>
                    </InputAdornment>
                  )}
                </>
              ),
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      color: "rgba(32, 33, 36, 0.3)",
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} mt="15px">
        {loading && (
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            item
            xs={12}
          >
            <CircularProgress size={30} />
          </Grid>
        )}
        {!loading && (
          <DocumentsTable
            handleDeleteDocument={handleDeleteDocument}
            handleFetchStoredDocuments={handleFetchStoredDocuments}
            handleRetrainDocuments={handleRetrainDocuments}
            setFileUploading={setFileUploading}
            setStoredDocuments={setStoredDocuments}
            storedDocuments={storedDocuments}
            isChatGPTAPIKeyValid={isChatGPTAPIKeyValid}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default StoredDocuments;
